import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=76153ce6&scoped=true&"
import script from "./customer.vue?vue&type=script&lang=js&"
export * from "./customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76153ce6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76153ce6')) {
      api.createRecord('76153ce6', component.options)
    } else {
      api.reload('76153ce6', component.options)
    }
    module.hot.accept("./customer.vue?vue&type=template&id=76153ce6&scoped=true&", function () {
      api.rerender('76153ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/tenders/customer.vue"
export default component.exports